<template>
  <div class="form-page">
    <div class="form-radio-multiple" v-for="(field, key) in history[currentStep].field.values">
      <div class="form-radio-multiple__label form-title">
        {{field.label}}
      </div>
      <div class="form-yes-no__wrap">
        <button class="form-button form-var"
                v-for="(value, index) in field.buttons"
                :key="index"
                :class="{'success': data[key] === !index}"
                :name="value"
                @click="handleInput(key, !index)">
          {{value}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'

export default {
  name: 'Multiple',
  data: function () {
    return {
      data: {}
    }
  },
  computed: mapState({
    history: state => state.history,
    currentStep: state => state.currentStep,
    config: state => state.config,
    provider: state => state.additionalParams.provider,
    country: state => state.additionalParams.country
  }),
  mounted () {
    const value = this.history[this.currentStep].value || []
    this.data = Object.keys(this.history[this.currentStep].field.values || {}).reduce((acc, key) => {
      acc[key] = value.includes(key) || null
      return acc
    }, {})
    this.$store.commit('UPDATE_FIELD', {isValid: true, value, withoutFilledEvent: true})
  },
  methods: {
    handleInput (key, value) {
      this.data[key] = value
      const result = []
      for (let key in this.data) {
        if (this.data[key]) result.push(key)
      }
      this.$store.commit('UPDATE_FIELD', {isValid: true, value: result})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/inputs";
.form-radio-multiple {
  width: 100%;

  &+& {
    margin-top: 20px;
  }
  &__label {
    text-align: left;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 20px;
  }
  &__wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 10px;
    gap: 5px;
  }
  &__button {
    margin: 0;
  }
}
.leadform .form-radio-multiple__label {
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/fields/Multiple.vue